import PropTypes from 'prop-types';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { CircularProgress } from '@material-ui/core';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const TourDateSelect = ({ days, value, month, onChange, onMonthChange, isLoading }) => {
  const runningDays = new Map(days.map((day) => [dayjs(day.date).format('YYYY-MM-DD'), day.date]));
  const start = month.startOf('month');
  const daysInMonth = month.daysInMonth();
  const isFirstMonth = !start.isAfter(dayjs().startOf('month'));
  const cells = [
    ...Array.from({ length: start.day() }, () => null),
    ...Array.from({ length: daysInMonth }, (unused, index) => start.add(index, 'day')),
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <button
          type="button"
          aria-label="Previous month"
          disabled={isFirstMonth}
          className={clsx('focus:outline-none', {
            'text-gray-300 cursor-default': isFirstMonth,
            'text-gray-600': !isFirstMonth,
          })}
          onClick={() => onMonthChange(month.subtract(1, 'month'))}
        >
          <MdKeyboardArrowLeft size="18" />
        </button>
        <span className="font-medium flex items-center gap-1">
          {month.format('MMMM YYYY')}
          {isLoading && <CircularProgress color="secondary" size={12} />}
        </span>
        <button
          type="button"
          aria-label="Next month"
          className="text-gray-600 focus:outline-none"
          onClick={() => onMonthChange(month.add(1, 'month'))}
        >
          <MdKeyboardArrowRight size="18" />
        </button>
      </div>

      <div className="grid grid-cols-7 text-center text-xs text-gray-500">
        {weekdays.map((weekday) => (
          <div key={weekday}>{weekday}</div>
        ))}
      </div>

      <div className={clsx('grid grid-cols-7 text-center text-sm', { 'opacity-50': isLoading })}>
        {cells.map((cell, index) => {
          if (!cell) {
            return <div key={`empty-${index.toString()}`} />;
          }
          const key = cell.format('YYYY-MM-DD');
          const runningDate = runningDays.get(key);
          const isSelected = !!value && dayjs(value).format('YYYY-MM-DD') === key;

          return (
            <button
              key={key}
              type="button"
              disabled={!runningDate}
              onClick={() => onChange(runningDate)}
              className={clsx('py-1 rounded focus:outline-none', {
                'text-gray-300 cursor-default': !runningDate,
                'hover:bg-gray-100': runningDate && !isSelected,
                'bg-theme text-white': isSelected,
              })}
            >
              {cell.date()}
            </button>
          );
        })}
      </div>
    </div>
  );
};

TourDateSelect.propTypes = {
  days: PropTypes.arrayOf(PropTypes.shape()).isRequired,

  value: PropTypes.string,
  month: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  onMonthChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

TourDateSelect.defaultProps = {
  value: undefined,
  isLoading: false,
};

export default TourDateSelect;
